import MuiLink from "components/MuiExtras/MuiLink";
import HtmlUtils from "lib/HtmlUtils";
import * as React from "react";
import { RoutePaths } from "routes/RouteConfig";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    id: string;
    name: string;
}

/////////////////////////////////////////////////////////////////////////////////////

export const TopicLinkTo: React.FC<IProps> = (props) => {
    return (
        <MuiLink
            onClick={() => HtmlUtils.openUrlInNewWindow(RoutePaths.TopicViewer.replace(":id", props.id))}
        >
            {props.name}
        </MuiLink>
    );
}

